import { TGeoValue } from '../../../packages/JsonQuery';

export function removeDistrictFromJsonQuery(geo: TGeoValue[] | null, id: number): TGeoValue[] {
  if (!geo) {
    return [];
  }

  const value = geo.filter(item => item.type !== 'district' || (item.type === 'district' && item.id !== id));

  return value.length === 0 ? [] : value;
}
